enum ApiNameEnum {
    FINANCING = "financing",
    ORIGINATION = "origination",
}

export default ApiNameEnum;
